export default "__VITE_ASSET__DzqrC7KT__"